import React from 'react';
import type { TransparenciaResponsavel } from '../services/transparenciaService';

/** Unidade responsável pelo portal, contato e ato de designação (TAEP P.1). */
const ResponsavelTransparencia: React.FC<{ responsavel: TransparenciaResponsavel }> = ({ responsavel }) => (
  <p className="w-full border-t border-slate-200 pt-2">
    <span className="font-semibold">Responsável pela publicação:</span>{' '}
    {responsavel.unidade || 'Não informado'}
    {responsavel.email && <> · <a href={`mailto:${responsavel.email}`} className="underline">{responsavel.email}</a></>}
    {responsavel.telefone && <> · {responsavel.telefone}</>}
    {responsavel.atoDesignacaoUrl && (
      <> · <a href={responsavel.atoDesignacaoUrl} target="_blank" rel="noopener noreferrer" className="underline">Ato de designação</a></>
    )}
  </p>
);

export default ResponsavelTransparencia;
